import $ from 'jquery';

$(document).ready(function() {
    if ($(window).width() < 1024) {
        $('.js-museum-events-slider').slick({
            dots: false,
            slidesToShow: 2.1,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            responsive: [
            {
                breakpoint: 520,
                settings: {
                    dots: false,
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                    arrows: false,
                    infinite: false,
               }
            }
            ]
        });
    }
});


// WEBPACK FOOTER //
// ./src/js/pages/one-museum/museum-events-slider.js